import Component from './Component';
import Flickity from 'flickity';


export default class TabbedContent extends Component {
  load() {
    this.initTabbedContent();
    super.load();
  }


  async initTabbedContent() {
    // let Flickity = await import('flickity');
    // console.log('typeof Flickity: ', typeof Flickity.default);

    const tabbedSlider = document.querySelectorAll('.tabbed-content .tabbed-content__tab-list');
    if(tabbedSlider) {
      Array.prototype.slice.call(tabbedSlider).map((el) => {
        new Flickity(el, {
          "cellAlign": "center",
          "contain": false,
          "wrapAround": true,
          "prevNextButtons": true,
          "pageDots": false,
          "watchCSS": true
        })
        .on('change', function( index ) {
          // hide all. show content
          $(".tabbed-content__tab-content").hide();
          $(".tabbed-content__tab-content[data-id='" + index + "']").fadeIn("fast");
        });

      });
    }

    $(".tabbed-content__tab-wrapper").on("click", function(event) {
      // hide all. show content
      const index = event.currentTarget.attributes["data-id"].nodeValue;

      // hide/show arrow
      $(".tabbed-content__arrow-movable").css('opacity',0);
      const arrow = event.currentTarget.children[1];
      arrow.style['opacity'] = 1;

      const tabs = $(".tabbed-content__tab-content");
      tabs.hide();
      $(".tabbed-content__tab-content[data-id='" + index + "']").fadeIn(500);

    });
  }
}
